import { SVGProps } from "react";

export const Bird2Icon = ({
  color = "currentColor",
  size = 16,
  strokeWidth = 1,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg width={size} height={size} {...rest} fill="none" viewBox="0 0 24 24">
      <path
        fill="none"
        d="M19 4.5h-3l-3.9 3.6 -1.6 -1.6H0.5l7.6 5.6L0.5 20l10 -4.5h5l2 -3.5v-2l3 -3.5 -1.5 -2Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M18 6.5 15 10v2h-3L7.5 8.5H3.2l4.9 3.6L0.5 20l10 -4.5h5l2 -3.5v-2l3 -3.5H18Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m13 9 -2.5 -2.5H0.5l9.5 7"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M12.1 8.1 16 4.5h3l1.5 2 -3 3.5v2l-2 3.5h-5L0.5 20l7.6 -7.9"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M17.5 6.5V7"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M20.5 6.5h3"
        strokeWidth={strokeWidth}
      ></path>
    </svg>
  );
  return render();
};
